import React from 'react';
import { useSelector } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import { getPlayerDuelState } from '../store/selectors/playerDuelSelector';
import PlayerDuel from '../PlayerDuel';
import playerDuelDataRequestAction from '../store/actions/playerDuelDataRequestAction';
import playerVsPitcherDataSource from '@gameday/core/datasources/playerVsPitcher';
import playerDuelReducer from '../store/reducers/playerDuelReducer';

const fetchData = () => {
    return playerDuelDataRequestAction();
};
initContainerData.register({
    datasources: {
        playerDuel: playerVsPitcherDataSource
    },
    reducers: {
        playerDuel: playerDuelReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const PlayerDuelDataContainer = (props) => {
    const playerDuelState = useSelector(getPlayerDuelState);

    return (
        <PlayerDuel { ...playerDuelState } { ...props } />
    );
};

export default PlayerDuelDataContainer;
export { fetchData, routes };
